import React, { useEffect } from "react";
import { GoogleMap, LoadScript, Marker ,MarkerF, MarkerClusterer} from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "470px",
};

const GoogleMapCard = ({
  currentLocationPharmacy,
  Selectedradio,
  currentLocation,
  zoom,
  mapInstance,
  setMapInstance,
  setBoundingBox,
  pharmacies
}) => {
  

  const defaultCenter = {
  lat: 0, 
  lng: 0
};



  const setMapBounds = () => {
    if (!mapInstance || !currentLocation) return;

    const bounds = new window.google.maps.LatLngBounds();
    bounds.extend(new window.google.maps.LatLng(currentLocation.lat + 0.1, currentLocation.lng + 0.1)); // NE
    bounds.extend(new window.google.maps.LatLng(currentLocation.lat - 0.1, currentLocation.lng - 0.1)); // SW

    mapInstance.fitBounds(bounds);
    
    const northEast = bounds.getNorthEast();
    const southWest = bounds.getSouthWest();

    const boundingBox = {
      northEast: { lat: northEast.lat(), lng: northEast.lng() },
      southWest: { lat: southWest.lat(), lng: southWest.lng() },
    };

    setBoundingBox(boundingBox);
      if (
        Selectedradio === "currentLocation" &&
        currentLocation.lat !== defaultCenter.lat &&
        currentLocation.lng !== defaultCenter.lng
      ) {
        currentLocationPharmacy(boundingBox);
      }
  };

  
  const updateBoundsAndCheckLocations = () => {
    if (!mapInstance) return;

    const bounds = mapInstance.getBounds();
    if (bounds) {
      const northEast = bounds.getNorthEast();
      const southWest = bounds.getSouthWest();

      const boundingBox = {
        northEast: { lat: northEast.lat(), lng: northEast.lng() },
        southWest: { lat: southWest.lat(), lng: southWest.lng() },
      };
      setBoundingBox(boundingBox);

    
    }
  };

  useEffect(() => {
  if (!mapInstance || pharmacies.length === 0) return;

  const bounds = new window.google.maps.LatLngBounds();

  pharmacies.forEach((location) => {
    const lat = parseFloat(location.Latitude);
    const lng = parseFloat(location.Longitude);

    if (!isNaN(lat) && !isNaN(lng)) {
      bounds.extend({ lat, lng });
      }
    });

    if (!bounds.isEmpty()) {
      mapInstance.fitBounds(bounds);
    }
  }, [pharmacies, mapInstance]);

//   if(pharmacies.length !=0){
//       const bounds = new window.google.maps.LatLngBounds();
     
// pharmacies.forEach(location => {
//     const lat = parseFloat(location.Latitude);
//     const lng = parseFloat(location.Longitude);

//     if (!isNaN(lat) && !isNaN(lng)) {
//       bounds.extend({ lat, lng });
//     } 
//   });
  
//       mapInstance.fitBounds(bounds);
      
//   }


  

  
  useEffect(() => {
    setMapBounds();
  }, [currentLocation, mapInstance]);


  return (
    <div>
      <LoadScript googleMapsApiKey="AIzaSyAj3iy85svUtJlq4aVBGIb-4Zb66kzY1qc">
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={currentLocation}
          zoom={zoom}
          onLoad={(map) => setMapInstance(map)}
          // onZoomChanged={updateBoundsAndCheckLocations}
          
          onIdle={updateBoundsAndCheckLocations}
          
options={{
    clickableIcons: false, 
    mapTypeControl: false,
    streetViewControl: false,
  }}

        
        >
          {/* {currentLocation && <Marker position={currentLocation} />} */}
{/*           
{pharmacies.map((pharmacy, index) => (
            <Marker
              key={index}
              position={{
                lat:  pharmacy.Latitude,
                lng: pharmacy.Longitude
              }}
              title={pharmacy.name}
                  onClick={() => {
      window.open(
        `https://www.google.com/maps/dir/?api=1&destination=${pharmacy.Latitude},${pharmacy.Longitude}`,
        "_blank"
      );
    }}
            />
          ))} */}
{/*           
<MarkerClusterer minimumClusterSize={10}>
  {(clusterer) => */}
    {pharmacies.map((pharmacy, index) => (
      <MarkerF
        key={index}
        position={{ lat: pharmacy.Latitude,
                    lng: pharmacy.Longitude }}
        // clusterer={clusterer}
           title={pharmacy.name}
        onClick={() => {
          window.open(
            `https://www.google.com/maps/dir/?api=1&destination=${pharmacy.Latitude},${pharmacy.Longitude}`,
            "_blank"
          );
        }}
      />
    ))
  }
{/* </MarkerClusterer> */}


        </GoogleMap>
      </LoadScript>
    </div>
  );
};

export default GoogleMapCard;

